import React, { useEffect, useState } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useNavigate } from "react-router-dom";
import { baseurladdress } from "../baseurl";
import axios from 'axios';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'


function Leaveassignmentlist() {
    const navigate = useNavigate();
    const accesstoken = localStorage.getItem("token");
    const Swal = require('sweetalert2')

    const [leaveassigndata, setleaveassigndata] = useState([]);


    const leaveassign = () => {
        navigate("/leaveassignment")
    }

    const leaveassignbulk = () => {
        navigate("/leavecontrolpanel")
    }


    const fetchLeaveassigndata = (e) => {
        console.log(accesstoken)
        axios
            .get(baseurladdress + "findallleaveassignment", {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                setleaveassigndata(res.data.response || []);
            })
            .catch((error) => {
                console.error("Error fetching leave policies:", error);
            });

    }

function handleDeleteClick(item) {
    Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
    }).then((result) => {
        if (result.isConfirmed) {
            axios
                .post(
                    `${baseurladdress}deleteleaveassign/${item.leaveassign_id}`,
                    {
                        leaveassign_policyid: item.leaveassign_policyid,
                        leaveassign_empid: item.leaveassign_empid,
                    },
                    {
                        headers: { Authorization: `Bearer ${accesstoken}` },
                    }
                )
                .then((response) => {
                    const { status, message } = response.data;

                    if (status === "deleted") {
                        // Destroy DataTable BEFORE state update so React can render cleanly
                        if ($.fn.DataTable.isDataTable('#leaveassignment')) {
                            $('#leaveassignment').DataTable().destroy();
                        }
                        Swal.fire({
                            icon: "success",
                            title: "Deleted",
                            timer: 2000,
                            showConfirmButton: false,
                            position: "top-end",
                            toast: true,
                        });
                        setleaveassigndata((prev) =>
                            prev.filter((data) => data.leaveassign_id !== item.leaveassign_id)
                        );
                    } else if (status === "active_period") {
                        Swal.fire({
                            icon: "info",
                            title: "Cannot delete active leave",
                            text: message,
                            timer: 3000,
                            showConfirmButton: false,
                            position: "top-end",
                            toast: true,
                        });
                    } else if (status === "cannot_delete") {
                        Swal.fire({
                            icon: "info",
                            title: "Deletion Not Allowed",
                            text: message,
                            timer: 3000,
                            showConfirmButton: false,
                            position: "top-end",
                            toast: true,
                        });
                    } else {
                        Swal.fire("Error", message || "Delete failed.", "error");
                    }
                })
                .catch(() => {
                    Swal.fire("Error", "Server error — please try again later.", "error");
                });
        }
    });
}



    useEffect(() => {
        fetchLeaveassigndata();
    }, [])

    function EditLeaveassignment(leaveassign_id) {
        navigate("/leaveassignmentedit/" + leaveassign_id);
    }

    useEffect(() => {
        const $table = $('#leaveassignment');
        
        // Destroy existing DataTable instance if any
        if ($.fn.DataTable.isDataTable('#leaveassignment')) {
            $table.DataTable().destroy();
            // Remove leftover DataTable wrapper elements/classes
            $table.off('.dt');
        }
        
        // Re-initialize DataTable when data exists
        if (leaveassigndata.length > 0) {
            // Use microtask to ensure DOM is fully committed before re-initializing
            Promise.resolve().then(() => {
                if (!$.fn.DataTable.isDataTable('#leaveassignment')) {
                    $table.DataTable();
                }
            });
        }
    }, [leaveassigndata]);


    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">
                        <section id="main-content">
                            <div className="card">
                                <div className="card-header" style={{ color: "black" }}>
                                    <h6 className="card-title d-inline-block">
                                        Leave Assignment Details
                                    </h6>

                                    <div className="d-flex align-items-center">
                                        <button
                                            type="button"
                                            className="btn plus-icon d-flex align-items-center"
                                            onClick={() => leaveassign()}
                                            style={{ marginRight: '50px' }}
                                        >
                                            <span style={{ fontSize: "1.2rem" }}><i className='fa fa-plus-circle text-success'></i></span>
                                            <span style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}> Add</span>
                                        </button>

                                        <button
                                            type="button"
                                            className="btn plus-icon d-flex align-items-center"
                                            data-tooltip-id="mytooltip"
                                            onClick={leaveassignbulk}
                                        >
                                            <span style={{ fontSize: "1.2rem" }}><i className='fa fa-plus-circle text-primary'></i></span>
                                            <span style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}> Bulk Add</span>
                                        </button>
                                    </div>
                                </div>

                                <div className="card-body">

                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-responsive-sm" id="leaveassignment">
                                                        <thead>
                                                            <tr>
                                                                <th>Sl.No</th>
                                                                <th>Employee Name</th>
                                                                <th>Leave Policy</th>
                                                                <th>Branch </th>
                                                                <th>Status</th>

                                                                <th>Edit</th>
                                                                <th>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {leaveassigndata.length > 0 ? (
                                                                leaveassigndata.map((item, index) => (
                                                                    <tr key={item.leaveassign_id} >
                                                                        <td>{index + 1}</td>
                                                                        <td>{item.leaveassign_empname}</td>
                                                                        <td>{item.leaveassign_policynum}</td>
                                                                        <td>{item.leaveassign_brnchname}</td>
                                                                        <td>
                                                                            {item.leaveassign_status === 1 ? (
                                                                                <span className="badge bg-success">Active</span>
                                                                            ) : (
                                                                                <span className="badge bg-danger">Inactive</span>
                                                                            )}
                                                                        </td>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            <i
                                                                                className="text-primary fa fa-edit"
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => EditLeaveassignment(item.leaveassign_id)}

                                                                            ></i>
                                                                        </td>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            <i
                                                                                className="text-danger fa fa-trash"
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => handleDeleteClick(item)}
                                                                            ></i>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="7" className="text-center">No data found</td>
                                                                </tr>
                                                            )}
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                            </div>


                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Leaveassignmentlist